import { Controller } from "stimulus"

export default class extends Controller {
  copy(event) {
    event.preventDefault()

    // Get the clicked element (the span with data-controller)
    const element = event.currentTarget
    const value = element.dataset.clipboardCopy || element.textContent.trim()

    navigator.clipboard.writeText(value).then(() => {
      // Visual feedback
      const originalBg = element.style.backgroundColor
      const originalColor = element.style.color

      element.style.backgroundColor = '#28a745'
      element.style.color = '#fff'

      setTimeout(() => {
        element.style.backgroundColor = originalBg
        element.style.color = originalColor
      }, 300)
    }).catch(err => {
      console.error('Failed to copy:', err)
    })
  }
}
